<section class="page-hero legal-hero" [attr.aria-labelledby]="page + '-page-title'">
  <div>
    <h1 [id]="page + '-page-title'">{{ title }}</h1>
  </div>
  <p>{{ intro }}</p>
</section>

<section class="section legal-page" aria-label="Legal information">
  <p class="legal-updated">Last updated: June 24, 2026</p>

  @if (page === 'privacy') {
    <div class="legal-panel">
      <article>
        <h2>Information we collect</h2>
        <p>
          When you submit an inquiry, Pavillion Properties may collect your name, phone number,
          email address, preferred development, and the message you choose to send.
        </p>
      </article>
      <article>
        <h2>How we use information</h2>
        <p>
          We use inquiry details to respond to viewing requests, availability questions, reservation
          interest, and related customer support. We do not sell inquiry information.
        </p>
      </article>
      <article>
        <h2>Email and service providers</h2>
        <p>
          Website inquiries may be processed through trusted email and hosting providers so our team
          can receive and respond to your request.
        </p>
      </article>
      <article>
        <h2>Your choices</h2>
        <p>
          You can ask Pavillion Properties to update or remove inquiry information by contacting the
          team through the contact details provided on this website.
        </p>
      </article>
    </div>
  } @else {
    <div class="legal-panel">
      <article>
        <h2>Website use</h2>
        <p>
          This website is provided for general property information, project discovery, and inquiry
          submission. Please do not misuse the site, interfere with its operation, or submit false
          information.
        </p>
      </article>
      <article>
        <h2>Property information</h2>
        <p>
          Prices, availability, imagery, finishes, and project details may change. Confirm all
          current terms directly with Pavillion Properties before making a purchase decision.
        </p>
      </article>
      <article>
        <h2>Reservations and payments</h2>
        <p>
          A unit is not reserved through website browsing alone. Reservation, deposit, payment plan,
          and legal completion terms must be confirmed through the official Pavillion Properties
          process.
        </p>
      </article>
      <article>
        <h2>External links</h2>
        <p>
          This website may link to third-party platforms for videos, maps, social media, or partner
          services. Those platforms operate under their own terms and policies.
        </p>
      </article>
    </div>
  }
</section>
